import Types from "./Types";

const INIT_STATE = {
    customerComplaintReasons:[],
    customerComplaintReason:{},
    count: 0,
    load: null,
    error: null,
};

export function customerComplaintsReasonsReducer(state = INIT_STATE, action) {
    const { type, payload } = action;
    switch (type) {
        case Types.CUSTOMER_COMPLAINT_REASONS_LOADING:{
            return {
                ...state,
                load: payload
            }
        }
        case Types.GET_CUSTOMER_COMPLAINT_REASONS_SUCCESS: {
            return {
                ...state,
                customerComplaintReasons: payload?.data?.order_complaint_reasons,
                count: payload?.extra?.total_count,
            };
        }

        case Types.GET_CUSTOMER_COMPLAINT_REASON_DETAILS_SUCCESS: {
            return {
                ...state,
                customerComplaintReason: payload?.data?.order_complaint_reason,
            };
        }
        case Types.ADD_CUSTOMER_COMPLAINT_REASON_SUCCESS: {
            console.log(payload);
            return {
                ...state,
            };
        }
        case Types.UPDATE_CUSTOMER_COMPLAINT_REASON_SUCCESS: {
            return {
                ...state,
            };
        }
        case Types.DELETE_CUSTOMER_COMPLAINT_REASON_SUCCESS: {
            return {
                ...state,
            };
        }
        default:{
            return state
        }
    }
}